export default __webpack_public_path__ + "static/how-to-8b0a15ddafcd33363cd4a5d7b6adfc40.png";